import * as buffer from "buffer"
window.Buffer = buffer.Buffer;
var crypto = require("../features/crypto-browserify/index");

const IV_LENGTH = 16; // For AES, this is always 16

const encryptText = (text, key) => {
  let iv = crypto.randomBytes(IV_LENGTH);
  let cipher = crypto.createCipheriv("aes-256-cbc", Buffer.from(key), iv);
  let encrypted = cipher.update(text);
  encrypted = Buffer.concat([encrypted, cipher.final()]);
  return iv.toString("base64") + ":" + encrypted.toString("base64");
};

const decryptText = (text, key) => {
  let textParts = text.split(":");
  let iv = Buffer.from(textParts.shift(), "base64");
  let encryptedText = Buffer.from(textParts.join(":"), "base64");
  let decipher = crypto.createDecipheriv("aes-256-cbc", Buffer.from(key), iv);
  let decrypted = decipher.update(encryptedText);

  decrypted = Buffer.concat([decrypted, decipher.final()]);

  return decrypted.toString();
};
const getSha256String = (str) => {
  let hash = crypto.createHash('sha256');
  hash.update(str);
  let shaString = hash.digest('base64');

  return shaString;
}
const getSha512String = (str) => {
  let hash = crypto.createHash('sha512');
  hash.update(str);
  let shaString = hash.digest('base64');

  return shaString;
}
const getScryptString = (str, salt)  => {
  // console.log("str",str,salt)
  let x = crypto.scryptSync(str, salt, 32).toString('base64')
  // console.log('x',x)
  return crypto.scryptSync(str, salt, 32).toString('base64')
}

export { encryptText, decryptText ,getScryptString,getSha512String,getSha256String};
